// extracted by mini-css-extract-plugin
module.exports = {"guide":"Guide_guide__1ae1I position-absolute pointerEvents-none borderStyle-dotted"};